import { Alert, Snackbar, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const Toast = ({ open, message, success, resetToast }) => {
  const [params, setParams] = useSearchParams();

  const handleClose = () => {
    params.delete("toastOpen");
    params.delete("success");
    params.delete("message");
    setParams(params);
    if (resetToast) {
      resetToast();
    }
  };

  if (
    (params.get("success") == "true" || success === true) &&
    (params.get("toastOpen") || open)
  ) {
    return (
      <Stack spacing={2} sx={{ width: "auto" }}>
        <Snackbar
          style={{ top: "10%" }}
          open={params.get("toastOpen") || open}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            className="sub-font"
            severity="success"
            sx={{ backgroundColor: "#e6faf1", color: "#2AC769" }}
            onClick={handleClose}
          >
            {params.get("message") || message}
          </Alert>
        </Snackbar>
      </Stack>
    );
  } else if (
    ((params.get("success") == "false" || !success) &&
      params.get("toastOpen")) ||
    open
  ) {
    return (
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          style={{ top: "10%" }}
          open={params.get("toastOpen") || open}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClick={(e) => handleClose()}
        >
          <Alert
            className="sub-font"
            severity="error"
            sx={{ backgroundColor: "##f9eded", color: "#ff4b4b" }}
            onClick={(e) => handleClose()}
          >
            {params.get("message") || message}
          </Alert>
        </Snackbar>
      </Stack>
    );
  }
};

export default Toast;
